import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { makeGetUser } from '../selectors/users';

import { fetchUser } from '../actions/users';

import { extractId } from '../utils/helpers';

const UserContainer = ({ id, user, children }) => {
    const doFetchUser = (userId, user) => {
        if (!userId || (user && !(user.shouldRefetch && !user.loading))) {
            return;
        }

        fetchUser(userId);
    }

    const getUserProps = (id, user) => {
        if (!user || (user.loading && !user.name)) {
            return {
                id,
                loading: true
            };
        }

        if (user.error) {
            return {
                id,
                error: true
            };
        }

        return {
            id,
            ...user
        };

    }

    useEffect(() => {
        doFetchUser(id, user);
    }, [id, user]);

    const userProps = getUserProps(id, user);

    return React.Children.map(children, child => React.cloneElement(child, userProps));
}

const makeMapStateToProps = () => {
    const getUser = makeGetUser();

    return ({ users }, ownProps) => {
        const id = extractId(ownProps.id);

        return {
            id,
            user: getUser(users, id)
        };
    };
}

export default connect(makeMapStateToProps)(UserContainer);
